import { Container, Row, Col, Card, Image } from "react-bootstrap";
import EnquiryForm from "../components/Enquiry/EnquiryForm";
import heroImage from "../Assets/Images/enroll-banner.jpg"; // Use any nice SVG/PNG image
import "./enroll.scss"; // Optional: Add custom styles for the page

const EnrollPage = () => {
  return (
    <div
      style={{
        background: "linear-gradient(90deg,#f4f8fd 0,#eaf1fa 100%)",
        minHeight: "100vh",
      }}
    >
      <Container className="py-5">
        {/* Hero Section */}
        <Row className="align-items-center mb-5">
          {/* <Col md={6} className="mb-4 mb-md-0">
            <h2 className="display-5 fw-bold mb-3">
              Start Your Learning Journey!
            </h2>
            <p className="lead text-secondary mb-4">
              Unlock your potential with our industry-ready courses. Fill out
              the form and our team will help you get started.
            </p>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <span className="fw-semibold">✔ Personalized guidance</span>
              </li>
              <li className="mb-2">
                <span className="fw-semibold">✔ 100% Placement Assistance</span>
              </li>
              <li>
                <span className="fw-semibold">
                  ✔ Live Projects & Certifications
                </span>
              </li>
            </ul>
            
          </Col> */}
          <Col md={12} className="text-center">
            <Image
              src={heroImage}
              alt="Enroll Now"
              fluid
              style={{ maxHeight: 400 }}
            />
          </Col>
        </Row>

        {/* Enquiry Form Section */}
        <Row className="justify-content-center">
          <Col lg={10} md={10}>
            <p className=" text-center text-muted mt-4 mb-4" style={{ fontSize: 15 }}>
              Fill out the form below and our admissions team will get in touch
              soon!
            </p>
            <EnquiryForm isGlobal={true} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EnrollPage;
